import { FeatureHelperService } from './../../_helpers/feature-helper/feature-helper.service';
import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core'
import { ControlData, UserSessionData } from '../../_models';
import { AuthenticationService } from '../../_services';
import { MatDialog } from '@angular/material/dialog';
import { SubmissionHistoryDialog } from '../../shared/submission-history-dialog';
import { MediaObserver, MediaChange } from '@ngbracket/ngx-layout';

@Component({
    selector: 'report-controls',
    templateUrl: 'report.controls.html',
    standalone: false
})


export class ReportControlsComponent implements OnInit, OnChanges {
  @Input() approved: boolean = false;
  @Input() canApprove: boolean;
  @Input() canReject: boolean = false;
  @Output() onApproved: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRejected: EventEmitter<any> = new EventEmitter<any>();
  currentUser: UserSessionData;

  public hasRejectPermission: boolean = false;
  public hasApprovePermission: boolean = false;

  constructor(
    private authService: AuthenticationService,
    public dialog: MatDialog,
    public media: MediaObserver,
    private featureHelperService: FeatureHelperService
    ) {
    this.currentUser = this.authService.userSessionData;
  }

  ngOnInit() {
    this.hasRejectPermission = this.canReject;
    this.hasApprovePermission = this.canApprove;
  }

  ngOnChanges() {
    this.hasRejectPermission = this.canReject;
    this.hasApprovePermission = this.canApprove;
  }

  public Approve() {
    this.onApproved.next('onApproved');
  }

  public openDialog() {
    const dialogRef = this.dialog.open(SubmissionHistoryDialog, {
      panelClass: 'my-dialog'
    });
    const sub = dialogRef.componentInstance.onConfirmed.subscribe((data) => {
      this.onRejected.next(data);
      dialogRef.close();
    });

  }
}
